import React from 'react'
import { FieldArray } from 'redux-form';

import AdServerSettings from './AdServerSettings';

type Props = {
  record: any
};

const AdServersTab = (props: Props) => (
  <div style={{ paddingTop: 20, paddingBottom: 60 }}>
    <FieldArray name="settings" component={AdServerSettings} label="Server Settings" record={props.record} />
  </div>
);

export default AdServersTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/AdServersTab.tsx